module.exports = __webpack_public_path__ + "static/media/SF-Pro-Text-Regular.f38dce0a.otf";